import React, { useContext, useState } from 'react'
import { CartContext } from '../Contexts/CartContext'
import CartProductsList from './CartProductsList';
import ChooseBox from './ChooseBox';
import PopupBg from './PopupBg';

const ShoppingCart = ({ closeModal, openCustomPopup }) => {
  const { cart, quantity, total } = useContext(CartContext);
  const [ next, setNext ] = useState(false);

  const goBack = () => {
    setNext(false);
  }

  return (
    <PopupBg closeModal={closeModal} opacity="transparent">
        {!next ?
          <div className="ShoppingCart">
            <div className="head">
              <h2>Panier : {quantity} variétés</h2>
              <div className="close" onClick={closeModal}>+</div>
            </div>
            
            <CartProductsList cart={cart} openCustomPopup={openCustomPopup} closeModal={closeModal} page="order" />

            {quantity > 0 &&
            <div className="totalbox">
              <div className="resume">
                <div className="title">Sous total</div>
                <div className="amount">{total} € HT</div>
              </div>
              <button onClick={() => setNext(true)}>
                Suivant
              </button>
            </div>
            }
          </div> :
          <ChooseBox goBack={goBack} />
        }
    </PopupBg>

    
  )
}

export default ShoppingCart